import httpManager from "../../../../shared/utils/httpManager";

/**
 * Obtener contacto.
 *
 * @param {Number} id
 * @return {Promise<Object>} Contacto
 */
export async function fetchReferralsClient(id) {
  const url = `/contacts/clients/${id}/contacts/`;
  const response = await httpManager.get(url);

  return response.data;
}
